export default function PracticeOverTheory() {
  const methods = [
    { icon: 'ri-phone-line', title: 'Реальные переговоры', desc: 'Прослушиваем и разбираем настоящие записи звонков и встреч участников. Это не искусственные кейсы — это их ежедневная работа.' },
    { icon: 'ri-phone-find-line', title: 'Реальные звонки', desc: 'Участники делают звонки реальным клиентам прямо во время тренинга. Тренер присутствует и даёт обратную связь в режиме реального времени.' },
    { icon: 'ri-user-search-line', title: 'Реальные клиенты', desc: 'Отработка навыков на действующих клиентах компании — максимально приближенная к реальности практика.' },
    { icon: 'ri-briefcase-line', title: 'Кейсы компании', desc: 'Все упражнения строятся на реальных сценариях из практики конкретной компании, а не на абстрактных примерах.' },
    { icon: 'ri-team-line', title: 'Ролевые игры', desc: 'Моделируем сложные ситуации: переговоры с несговорчивым клиентом, работа с возражениями на этапе диагностики.' },
    { icon: 'ri-error-warning-line', title: 'Разбор ошибок', desc: 'Детальный анализ неудачных диалогов: что пошло не так, какой вопрос нужно было задать, как перестроить разговор.' },
    { icon: 'ri-feedback-line', title: 'Индивидуальная обратная связь', desc: 'Каждый участник получает персональные рекомендации по усилению навыков. Без общих фраз — только конкретика.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-tools-line"></i>
            80% практики
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Практика вместо лекций
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Восемьдесят процентов времени участники работают. Никаких долгих теоретических блоков — только реальные инструменты, которые можно применить сразу после тренинга.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-4xl mx-auto mb-12">
          {methods.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-xl text-teal-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-20 h-20 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <div className="text-center">
              <div className="text-3xl font-extrabold text-white">80/20</div>
            </div>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            80% времени — практика. 20% — инструменты и методология. Потому что навык формируется только через действие, а не через конспекты.
          </p>
        </div>
      </div>
    </section>
  );
}